import React, { Component } from "react"
import { Container, Col, Row, Card, CardBody  } from "reactstrap"
import {Link} from "react-router-dom";
import ModalCreate from "./modalCreate"
import {apiPaths} from "../../config/constants";
import mainFunctions from "../../components/Functions";
import Request from "superagent";
import BrandsDatatable from "./datatable"
import toastr from 'toastr'
import Pages from "../../components/Pages"
import ModalUpdateBrand from "./ModalUpdateBrand"
import ModalDeleteBrand from "./ModalDeleteBrand"

class Brand extends Component {
  constructor(props) {
    super(props)
    this.state = {
      page: 1,
      page_size: 50,
      total_rows: 0,
      q: '',
    }

    this.new_brand_name_ref = React.createRef();
  }
  componentDidMount() {
    this.brands();
  }
  brands = () => {
    setTimeout(function() {
      const { page, page_size, q } = this.state;
      let query = { page: page, pageSize: page_size, q: q }

      Request
        .get(apiPaths.brands + mainFunctions.formattedGet(query, false))
        .set('Accept', 'application/json')
        .set(mainFunctions.headers())
        .then((response) => {
          if (response.body && response.body.data) {
            let data = response.body.data;
            this.setState({
              brands: data.brands,
              total_rows: data.total_rows,
            });
          }
        }).catch((error) => {
        this.setState({
          errorMessage: "Ha ocurrido un error en el servidor. Por favor, intenta nuevamente luego."
        })
      });
    }.bind(this), 20);
  };
  togCreateBrand = () => {
    this.setState({ modal_create_brand: !this.state.modal_create_brand });
  }
  createBrand = () => {
    const name = this.new_brand_name_ref.current.value
    if(!name || name.length === 0 ) return;

    this.setState({ modal_create_brand: false });
    let post = { name: name };

    toastr.options = mainFunctions.toastrOptions();
    Request
      .post(apiPaths.brands)
      .set('Accept', 'application/json')
      .set(mainFunctions.headers())
      .send(post)
      .then((response) => {
        if(response.status >= 200 && response.status <= 299) {
          const { brands } = response.body;
          mainFunctions.setBrands(brands);
          this.brands();
        } else {
          toastr["warning"]("Error inesperado", "Marca");
        }
        
      }).catch((error) => {
      this.setState({
        isSending: false,
        errorMessage: "Ha ocurrido un error en el servidor. Por favor, intenta nuevamente luego."
      })
    });
  }
  showBrandModal = (brand) =>{
    this.setState({ current_brand: brand });
    this.tog_standard();
  };
  tog_standard = () => {
    this.setState({ modal_standard: !this.state.modal_standard });
  };
  deleteBrandModal = (brand) =>{
    this.setState({ current_brand: brand });
    this.tog_delete();
  };
  tog_delete = () => {
    this.setState({ modal_delete: !this.state.modal_delete });
  };
  setPage = (value) => {
    this.setState({ page: value });
    this.brands();
  };

  updateCurrentBrandInput = (value) => {
    const {current_brand} = this.state;
    current_brand.name = value;
  };
  updateCurrentBrand = () => {
    const { current_brand } = this.state;
    const { id, name } = current_brand;

    const cat = {
      name: name
    };
    toastr.options = mainFunctions.toastrOptions();

    Request
      .put(`${apiPaths.brands}/${id}`)
      .set('Accept', 'application/json')
      .set(mainFunctions.headers())
      .send(cat)
      .then((response) => {
        if(response.status >= 200 && response.status <= 299) {
          const { brands } = response.body;
          mainFunctions.setBrands(brands);
          this.brands();
        } else {
          toastr["warning"]("Error inesperado", "Marca");
        }
      }).catch((error) => {
      this.setState({
        isSending: false,
        errorMessage: "Ha ocurrido un error en el servidor. Por favor, intenta nuevamente luego."
      })
    });
  }
  deleteCurrentBrand = () => {
    const { current_brand } = this.state;
    const { id } = current_brand;
    toastr.options = mainFunctions.toastrOptions();

    Request
      .delete(`${apiPaths.brands}/${id}`)
      .set('Accept', 'application/json')
      .set(mainFunctions.headers())
      .send({})
      .then((response) => {
        if(response.status >= 200 && response.status <= 299) {
          const { brands } = response.body;
          mainFunctions.setBrands(brands);
          this.setState({ modal_delete: false });
          this.brands();
        } else {
          toastr["warning"]("Error inesperado", "Marca");
        }
      }).catch((error) => {
      this.setState({
        isSending: false,
        errorMessage: "Ha ocurrido un error en el servidor. Por favor, intenta nuevamente luego."
      })
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Row>
              <Col xs="12">
                <div className="page-title-box d-flex align-items-center justify-content-between">
                  <h4 className="mb-0 font-size-18">Marcas</h4>
                  <div className="page-title-right">
                    <Link href="#" className="bx bx-plus-circle font-size-24 mr-2 brand-new" style={{ color: '#495057' }}  onClick={() => this.togCreateBrand()}/>
                    <ModalCreate
                      modal_standard={this.state.modal_create_brand}
                      tog_standard={() => this.togCreateBrand()}
                      new_brand_name_ref={this.new_brand_name_ref}
                      createBrand={() => this.createBrand()}
                    />
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                <Card>
                  <CardBody>
                    <BrandsDatatable
                      brands={this.state.brands}
                      open_brand_modal={(brand) => this.showBrandModal(brand)}
                      delete_modal={(brand) => this.deleteBrandModal(brand)}
                    />
                    <Pages
                      page={this.state.page}
                      page_size={this.state.page_size}
                      total_rows={this.state.total_rows}
                      onClickPage={value => this.setPage(value)}
                    />
                    <ModalUpdateBrand
                      modal_standard={this.state.modal_standard}
                      tog_standard={() => this.tog_standard()}
                      brand={this.state.current_brand}
                      onChangeInput={(value) => this.updateCurrentBrandInput(value)}
                      updateCurrentBrand={this.updateCurrentBrand}
                    />
                    <ModalDeleteBrand
                      modal_standard={this.state.modal_delete}
                      tog_standard={() => this.tog_delete()}
                      brand={this.state.current_brand}
                      deleteCurrentBrand={this.deleteCurrentBrand}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

export default Brand;
